module.exports = __webpack_public_path__ + "img/default-img.276d9a8d.jpg";